<template>
  <section v-maximizable>
   <div class="table-tab__container" tabindex="1" style="overflow: auto; outline: none;" v-if="report">
    <div class="a-container-form ">
      <div class="a-flex-start a-width-100-percent">
        <dropdown-new class="select-w-260 u-margin-right-20"
                      v-model="selectionMode" >
          <option value="none" :label="'Показать все'"></option>
          <option value="show-selected" :label="'Показывать выделенные'"></option>
          <option value="hide-selected" :label="'Скрыть выделенные'"></option>
        </dropdown-new>
        <button class="gui-btn gui-btn--red  gui-btn--w-127" @click.prevent="onResetSelectionClick">{{$t('buttons.reset')}}</button>
      </div>
    </div>

    <table class="table-tab__block table" style="min-width: 1400px">
      <thead>
      <tr>
        <th></th>
        <th colspan="8"></th>
        <template v-for="bid in bids" >
          <th class="table-tab__color-border-left"
              :colspan="2 + (detailedViewMode[bid.id] ? 2 + criteria.length + reductionCriteria.length : 0)">
            <router-link class="table-tab__color u-text-underline"
                         :to="{name: 'purchases-public-lot-alien-bid', params: { lotId: lot.id, requestId: bid.request, bidId: bid.id, tab: 'bid'}}">
              {{bid.participant}}<br>
              Предложение #{{bid.num}}
            </router-link>
          </th>
          <th class="table-tab__color-border-right">
            <button class="gui-btn gui-btn--white-border gui-btn--w-127" @click.prevent="$set(detailedViewMode, bid.id, !detailedViewMode[bid.id])">
              {{detailedViewMode[bid.id] ? 'Свернуть': 'Подробнее'}}
            </button>
          </th>
        </template>
      </tr>
      </thead>
      <thead class="table-tab__thead">
        <tr class="table-tab__tr">
          <th class="table-tab__th--row table-tab__border-right"></th>
          <th class="table-tab__th--row table-tab__border-right">№</th>
          <th>
            {{canSetWinner ? $t('form.lot.reduction-report.winner'):  $t('form.lot.reduction-report.leader')}}
          </th>
          <th>{{ $t('form.lot.reduction-report.nomenclature')}}</th>
          <!--<th>Производитель</th>-->
          <th class="text-nowrap">{{ $t('form.lot.reduction-report.quantity')}}</th>
          <th>{{ $t('form.lot.reduction-report.unit')}}</th>
          <th>{{ $t('form.lot.reduction-report.customer-price-per-unit')}}</th>
          <th>{{ $t('form.lot.reduction-report.customer-sum')}}</th>
          <th>{{ $t('form.lot.reduction-report.best-bid')}} <br> ({{ $t('form.lot.reduction-report.final-estimation')}})</th>
          <!--<th>Итоговая оценка по <br> экспертнооцениваемым <br> критериям</th>-->

          <template v-for="bid in bids">
            <th class="table-tab__color-border-left">{{ $t('form.lot.reduction-report.rating')}}</th>

            <template v-if="detailedViewMode[bid.id]">
              <th v-for="c in reductionCriteria">{{c.name}} ({{c.weight | percent}}%)</th>
              <th v-for="c in criteria">{{c.name}} ({{c.weight | percent}}%)</th>
              <th>{{ $t('form.lot.reduction-report.estimation-of-present-price')}}</th>
              <th>{{ $t('form.lot.reduction-report.final-estimation')}}</th>
            </template>

            <th>{{ $t('form.lot.reduction-report.present-price')}} ({{reducedPriceWeight | percent}}%)</th>
            <th class="table-tab__color-border-right">{{ $t('form.lot.reduction-report.price')}}</th>
          </template>
        </tr>
      </thead>
      <tbody class="table-tab__tbody">
        <tr v-for="(row, rowId) in specs" :key="`spec-${row.position}`">
          <td class="table-tab__th--row table-tab__border-right">
            <input type="checkbox" v-model="selection[row.position]"/>
          </td>
          <th class="table-tab__th--row table-tab__border-right">
            {{rowId + 1}}
          </th>
          <td class="text-nowrap">
            <dropdown-new style="width: 140px"
                          :placeholder="'form.lot.reduction-report.winner'"
                          :value="row.winner"
                          @input="onWinnerChanged(row, $event)"
                          :options="possibleWinners(row)"
                          v-if="canSetWinner" >
              <option value :label="'labels.no-winner-selected'"></option>
            </dropdown-new>
            <span v-else-if="leaders[rowId]">
              {{leaders[rowId].participant}}<br>
              {{$t('form.lot.bid', {id: leaders[rowId].num})}}
            </span>
          </td>
          <td>{{row.name}}</td>
          <!--<td>{{row.vendor}}</td>-->
          <td>{{row.count}}</td>
          <td>{{row.okei}}</td>
          <td>{{row.price | price}}</td>
          <td>{{row.total | price}}</td>
          <td>{{row.bestBid.estimate | finalEstimation | defaultValue('-')}}</td>

          <template v-for="bid in bids">
            <td class="table-tab__color-border-left"
                :class="{'table-tab__background--green': row.bids[bid.id].isBest}">
              {{row.bids[bid.id].rank | defaultValue('-')}}
            </td>

            <template v-if="detailedViewMode[bid.id]">
              <td :class="{'table-tab__background--green': row.bids[bid.id].isBest}"
                  v-for="c in reductionCriteria">
                {{row.bids[bid.id].reductionCriteria[c.id] | get('value') | price | defaultValue('-')}}
                {{row.bids[bid.id].reductionCriteria[c.id] | get('okei') }}
              </td>
              <td :class="{'table-tab__background--green': row.bids[bid.id].isBest}"
                  v-for="c in criteria">
                {{row.bids[bid.id].criteria[c.id] | get('estimate') | estimation | defaultValue('-')}}
              </td>
              <td :class="{'table-tab__background--green': row.bids[bid.id].isBest}">
                {{row.bids[bid.id].presentPriceEstimate | estimation | defaultValue('-')}}
              </td>
              <td :class="{'table-tab__background--green': row.bids[bid.id].isBest}">
                {{row.bids[bid.id].estimate | finalEstimation | defaultValue('-')}}
              </td>
            </template>

            <td :class="{'table-tab__background--green': row.bids[bid.id].isBest}">
              {{row.bids[bid.id].presentPrice | present-price | defaultValue('-')}}
            </td>

            <td class="table-tab__color-border-right"
                :class="{'table-tab__background--green': row.bids[bid.id].isBest}">
              <p class=" table-tab__tr-w-70"
                 :class="{
                  'table-tab__color-information': row.bids[bid.id].participantPrice === row.bids[bid.id].minParticipantPrice,
                  'table-tab__color-information table-tab__background-red': row.price > 0 && row.bids[bid.id].participantPrice > row.price
                 }">
                {{row.bids[bid.id].participantPrice | price | defaultValue('-')}}
              </p>
            </td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
  </section>
</template>

<script>
  import _ from "lodash";
  import Errors from '@/api/types/errors'

  export default {
    props: {
      lot: {
        type: Object,
        required: true
      },

      report: {
        type: Object
      }
    },

    data: () => ({
      detailedViewMode: {},
      selection: {},
      selectionMode: 'none'
    }),

    computed: {
      specs() {
        if (this.selectionMode === 'none') {
          return this.report.specs;
        }

        return this.report.specs.filter(s => {
          if (this.selectionMode === 'show-selected') {
            return !!this.selection[s.position];
          }
          else if (this.selectionMode === 'hide-selected') {
            return !this.selection[s.position];
          }
        })
      },

      bids() {
        return this.report.bids;
      },

      criteria() {
        return this.report.criteria;
      },

      reductionCriteria() {
        return this.report.reductionCriteria;
      },

      reducedPriceWeight() {
        return _.get(this.lot.criteria.reducedPrice, '[0].weight');
      },

      requests() {
        return this.lot.requests.filter(r => r.state.APPROVED);
      },

      canSetWinner() {
        return this.lot.permissions.CAN_SEE_PUBLIC_LOT_ACCEPT_BID;
      },

      leaders() {
        return this.specs.map(s => {
          const best = _.findKey(s.bids, { isBest: true });

          if (best) {
            const found = _.find(this.bids, { id: +best });
            return found;
          }
        })
      }
    },


    watch: {
      'lot.requests'() {
        console.info('updated lot.requests in main');
      },

      report() {
        console.info('updated report in main');
      },

      lot: {
        handler() {
          console.info('updated lot in main');
        },
        deep: true
      }
    },

    updated() {
      console.info('component is updated');
    },

    methods: {
      getBestBid(request, position) {
        let summaries = _.filter(this.lot.requestsTotal.summary, { position });
        summaries = _.orderBy(summaries, 'estimate', 'desc');

        const idx = _.findIndex(summaries, {
          requestId: request.num,
          position
        });

        if (idx === -1) return {};

        const bid = _.find(request.bids, { id: summaries[idx].bid });

        const data = _.get(_.find(this.lot.requestsTotal.data, { request: request.num}), 'specs');
        const spec = _.find(data, { bid: bid.id, position})

        return {
          ...bid,
          rank: idx + 1,
          positionEstimate: summaries[idx].estimate,
          positionPresentPriceEstimate: summaries[idx].presentPriceEstim / 10,
          positionPresentPrice: _.get(spec, 'presentPrice')
        }
      },

      possibleWinners({position}) {
        const summary = _.get(this.lot.requestsTotal, 'summary');

        return this.bids.map(b => ({
          id: b.id,
          disabled: !_.find(summary, { bid: b.id, position }),
          name: `${b.participant} - ${this.$t('form.lot.bid', {id: b.num})}`
        }));
      },

      getBestEstimation(position) {
        let summaries = _.filter(this.lot.requestsTotal.summary, { position });
        summaries = _.orderBy(summaries, 'estimate', 'desc');

        return _.get(summaries, '[0].estimate');
      },

      getSpecPosition(request, position) {
        const bid = this.getBestBid(request, position);

        return {
          ..._.find(bid.specs, { position }),
          estimate: bid.positionEstimate,
          presentPrice: bid.positionPresentPrice,
          presentPriceEstimate: bid.positionPresentPriceEstimate
        }
      },

      getCriteriaEstimate(request, position, criteria) {
        const requestSummary = _.find(this.lot.requestsTotal.data, { request: request.num });
        const criteriaSummary = _.get(requestSummary, 'criterions');

        const bid = this.getBestBid(request, position);
        let summary = _.find(criteriaSummary, {
          bidNum: bid.num,
          position,
          num: criteria.num
        });

        if (!summary) {
          summary = _.find(criteriaSummary, {
            bidNum: bid.num,
            position: 0,
            num: criteria.num
          });
        }

        return _.get(summary, 'estimate')
      },

      getCriteriaValue(request, position, criteria) {
        const requestSummary = _.find(this.lot.requestsTotal.data, { request: request.num });
        const criteriaSummary = _.get(requestSummary, 'criterions');

        const bid = this.getBestBid(request, position);
        let summary = _.find(criteriaSummary, {
          bidNum: bid.num,
          position,
          num: criteria.num
        });

        if (!summary) {
          summary = _.find(criteriaSummary, {
            bidNum: bid.num,
            position: 0,
            num: criteria.num
          });
        }

        return _.get(summary, 'value')
      },

      minCriteriaValue(position, criteria) {
        const min = _.min(this.lot.requestsTotal.data.map(r => {
          const prices = _.filter(_.get(r, 'criterions'), { num: criteria.num }).map(e => e.value);
          return _.min(_.compact(prices).map(e => +e));
        }));

        return min;
      },

      async onWinnerChanged(row, winner) {
        this.runBlockerAction(async() => {
          try {
            await this.$store.dispatch('updateWinner', {
              lotId: this.lot.id,
              position: row.position,
              bid: winner
            });
          }
          catch(e) {
            console.error('unable to change winner for position', e);
            this.globalErrorHandler(e, {
              'INVALID_DATA': 'errors.public-lot.setting-winner.participant-cannot-be-winner-for-position',
              'ACCESS_DENIED': 'errors.public-lot.setting-winner.access-denied',
              'INVALID_STATE': 'errors.public-lot.setting-winner.invalid-lot-state'
            }, 'errors.public-lot.setting-winner.unknown');
          }
        })
      },

      onResetSelectionClick() {
        this.selectionMode = 'none';
        this.selection = {};
      }
    }
  }
</script>

<style scoped>

</style>
